export default __webpack_public_path__ + "static/media/workflow-editor-bg.df1363ff.png";